const copy = {
  articlesCount: (count: number): string => `${count} articles`,
  viewMore: 'View more',
}

export default copy;
